'use client';

import { cn } from '../../lib/utils/cn';
import { Flex } from '../atoms/flex';
import { Input, type InputProps } from '../input/input';
import { useSliderInputs } from './hooks/use-slider-inputs';

export type SliderInputsProps = InputProps;

export const SliderInputs = ({ className, classNames, ...inputProps }: SliderInputsProps) => {
  const { isRange, inputMode, getControlledProps } = useSliderInputs();

  const renderInput = (index: number) => (
    <Input
      key={`slider-input-${index}`}
      inputMode={inputMode}
      aria-label={isRange ? (index === 0 ? 'Minimum value' : 'Maximum value') : 'Value'}
      {...inputProps}
      {...getControlledProps(index)}
      className={cn('text-center', className)}
      classNames={{
        ...classNames,
        wrapper: cn('w-[60px]', classNames?.wrapper),
      }}
    />
  );

  return (
    <Flex className={cn('w-full items-center gap-3', isRange && 'justify-between')}>
      {isRange ? (
        <>
          {renderInput(0)}
          {renderInput(1)}
        </>
      ) : (
        renderInput(0)
      )}
    </Flex>
  );
};
